<template>
  <v-card class="group-header rounded-0 ignoreodd" :dark="dark" flat :color="color" :class="{ sticky: sticky }" link>
    <SelectableListItemWrapper :previewable="previewable" :isPreviewed="isPreviewed" :showCheckbox="showCheckbox"
      :isChecked="isChecked" :toggleCheckbox="toggleCheckbox" :openPreview="openPreview" :closePreview="closePreview"
      @PrimaryClick="$emit('PrimaryClick')" @MiddleClick="$emit('MiddleClick')">

      <template v-slot:list-item>
        <slot>
          <div class="d-flex align-center px-3" style="height: 32px;">
            {{ text }}
          </div>
        </slot>
      </template>

    </SelectableListItemWrapper>
  </v-card>
</template>


<script>
import SelectableListItemWrapper from "@/components/ListItems/SelectableListItemWrapper.vue";

export default {
  name: 'GenericListSubHeader',
  props: {
    text: [String, Number, Object],
    color: {
      type: String,
      default: '#fafafa'
    },
    dark: Boolean,
    sticky: Boolean,
    multiple: Boolean,
    previewable: Boolean,
    isChecked: Boolean,
    showCheckbox: Boolean,
    isPreviewed: Boolean,

    openPreview: {
      type: Function,
      default: () => { }
    },
    closePreview: {
      type: Function,
      default: () => { }
    },
    toggleCheckbox: {
      type: Function,
      default: () => { }
    }
  },
  components: {
    SelectableListItemWrapper,
  },

  data() {
    return {};
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped>
.group-header {
  font-weight: 600;
  opacity: 1;
}

.group-header {
  position: sticky;
  top: 0;
  /* stick to the top of the scrolling v-list */
  z-index: 2;
  /* above list items */
  background: inherit;
  /* avoid transparent overlap when scrolling */
  /* Optional polish */
  backdrop-filter: saturate(180%) blur(4px);
  /* subtle divider line */
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.08), 0 -1px 0 rgba(0, 0, 0, 0.06) !important;
  font-weight: 600;
}
</style>